export const MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export const CURRENCY_SYMBOLS: { [key: string]: string } = {
    USD: "$",
    EUR: "€",
    GBP: "£",
};
